export enum Constants {
  LINKS_SET_LINKS = 'LINKS_SET_LINKS',
  LINKS_ADD_LINK = 'LINKS_ADD_LINK'
}